<template>
  <div id="header-container">
    <div id="logo-container-desk">
      <img id="logo-mm" src="./Logo_Move_Mais.svg" />

      <div id="line"></div>

      <img id="logo-pamcard" src="./Logo_Pamcard_Branco_seta_amarela.svg" />
    </div>

    <div id="logo-container-mob">
      <img src="./mmMob.svg" />
      <div id="line"></div>
      <img src="./pamcardMob.svg" />
    </div>

    <div id="info-container">
      <h4 @click="scrollToElement('planos')" style="cursor: pointer">PLANOS</h4>
      <h4 @click="scrollToElement('beneficios')" style="cursor: pointer">
        BENEFÍCIOS
      </h4>
      <h4 @click="scrollToElement('footer')" style="cursor: pointer">
        CONTATO
      </h4>
    </div>

    <!-- Descartado do projeto -->
    <!-- <div id="menu-hamburguer">
      <img src="./menu.svg" />
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      elemento: undefined,
    };
  },

  methods: {
    scrollToElement(id) {
      if (id == "footer") {
        this.elemento = document.getElementById("footer-hotsite");
      }
      if (id == "planos") {
        this.elemento = document.getElementById("plans-title");
      }

      if (id == "beneficios") {
        this.elemento = document.getElementById("beneficios-container");
      }
      if (this.elemento) {
        this.elemento.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style lang="scss">
#logo-container-desk {
  display: none;
}

#logo-container-mob {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 1rem;
}

#header-container {
  width: 100%;
  height: fit-content;
  padding: 1rem 0;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;
}

#logo-mm {
  width: 20%;
}

#logo-pamcard {
  width: 47%;
}

#line {
  height: 60%;
  border: solid 1px #1c345442;
  margin: 0 1rem;
}

#info-container {
  display: none;
  font-size: 14px;
}

#menu-hamburguer {
  margin-right: 2rem;
}

@media (min-width: 600px) {
  #logo-container-desk {
    height: 100%;
    display: flex;
    margin-left: 10rem;
    align-items: center;
  }
  #logo-container-mob {
    display: none;
  }
  #line {
    height: 80%;
    border: solid 1px #1c345442;
    margin: 0 1rem;
  }
  #menu-hamburguer {
    display: none;
  }
  #info-container {
    display: flex;
    align-items: center;
    margin-right: 7rem;
    font-size: 14px;
    h4 {
      margin: 0 2rem;
      color: #fff;
    }
  }
  #logo-container {
    margin-left: 10rem;
  }
  #header-container {
    width: 100%;
    height: 147px;
    padding: 1rem 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background-color: rgba(255, 255, 255, 0.5);
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// header-hot-site.vue?4148f5fe